import { translateHTML } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import { MessageState } from './reducer';

export enum Types {
  SET = 'MESSAGE_SET',
  UNSET = 'MESSAGE_UNSET',
  SET_SEEN = 'MESSAGE_SET_SEEN',
}

export type Action = SetAction | UnsetAction | SetSeenAction;

type SetAction = {
  type: Types.SET;
  payload: Omit<MessageState, 'seen'>;
};

type UnsetAction = {
  type: Types.UNSET;
};

type SetSeenAction = {
  type: Types.SET_SEEN;
};

export const setMessage = (
  message: ITranslations,
  location: string,
  type: MessageState['type'] = undefined,
  values?: Record<string, string>,
): SetAction => ({
  type: Types.SET,
  payload: {
    message: translateHTML(message, values),
    location,
    type,
  },
});

export const unsetMessage = (): UnsetAction => ({
  type: Types.UNSET,
});

export const setMessageAsSeen = (): SetSeenAction => ({
  type: Types.SET_SEEN,
});
